<template>
  <span class="amount">
    <span v-if="currency">{{ symbol }}</span>
    <span ref="textRef">{{
      value || value == "0" ? value.toFixed(2) : ""
    }}</span>
    <span v-if="suffix" style="margin-right: 3px">{{ suffix }}</span>
  </span>
</template>
<script lang="js">
import store from '../store';
export default {
name:'dk-amount-text',
props:['currency','value','suffix'],
computed:{
  symbol(){
   let currencyMap =  store.getters["getCurrencyMap"]
    return currencyMap[this.currency]?.symbol || ''
  }
},
data(){
  return {}
}
}
</script>
<style scoped>
.amount {
  display: inline-block;
}
</style>
